import { Alert, Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { DatePicker } from "@mui/x-date-pickers";
import React, { useState } from "react";
import { AutoCompleteInputWithLabel } from "../../form/custom-imputs";
import { AxiosInstance } from "../../../utils/constants";


export default function RegistroSolicitud ({
    opened,
    onCloseModal,
    onsendForm,
    fecha_entrega=null
}){
       const [formData,setFormData] = useState({
        fecha_entrega:fecha_entrega,
        fecha_recogida:null,
        tipo_vehiculo:null,
        hasError:""
       });
       const [fecha_recogida,setFechaRecogida] = useState(null);
       const [fechaEntregaPrefered,setFechaEntregaPrefered] = useState(fecha_entrega);
       const [tipo_vehiculo,setTipoVehiculo] = useState([]);

        const onChangeFechaRecogida = (value)=>{
         
            setFormData({...formData,fecha_recogida:value});
        }
        const onChangeFechaEntrega = (value)=>{
            setFormData({...formData,fecha_entrega:value});
           
        }

        React.useEffect(()=>{
            loadTiposVehiculos();
        },[]);

        const loadTiposVehiculos = ()=>{
            AxiosInstance.post("maestros/obtener-tipos-vehiculos").then(({data})=>{
                console.log({data});
                setTipoVehiculo( data.value?.data?.map( item=>({label:item.descripcion+"-"+item.tipo,value:item.cod}) ) );
            });
        }

        const onCreateSolicitud = ()=>{
            let hasError= "" ;
             Object.keys(formData).map( key=>{
                if ( formData[key] === null ){
                    hasError = `Algunos campos no estan completos`;
                }
            } );
            setFormData({...formData,hasError});

            if ( !hasError){
                onsendForm(formData);
            }
        }

        console.log({formData});
    return (
        <Dialog
        open={opened}
        >
            
            <DialogContent>
            <DialogTitle>Agregar solicitud</DialogTitle>
                <Grid container spacing={2} >
                        <Grid item xs={12} md={6} sm={12} >
                                <DatePicker  
                                value={formData.fecha_recogida}
                                onChange={onChangeFechaRecogida}
                                label='Fecha de recogida'
                                slotProps={{ textField: {} }}
                                />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}  >
                                <DatePicker  
                                disabled
                                value={formData.fecha_entrega}
                                onChange={onChangeFechaEntrega}
                                label='Fecha de entrega'
                                slotProps={{ textField: { fullWidth: true } }}
                                />
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}  >
                            <FormControl fullWidth >
                                <InputLabel id="select-vehicle" >Tipo de vehiculo</InputLabel>
                                <Select 
                                value={formData.tipo_vehiculo}
                                fullWidth
                                id="select-v"
                                labelId="select-vehicle"
                                onChange={e=>setFormData({...formData,tipo_vehiculo:e.target.value})}
                                >
                                    {console.log({tipo_vehiculo})}
                                    {
                                        tipo_vehiculo.map( vehic=><MenuItem key={vehic.value} value={vehic.value} >{vehic.label}</MenuItem> )
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}  >
                            {
                                formData.hasError && 
                                <Alert severity="error" >
                                    {formData.hasError}
                                </Alert>
                            }
                       
                           

                        </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
            <Button onClick={onCloseModal} variant="contained" color="error" >Cancelar</Button>
                <Button onClick={onCreateSolicitud} variant="contained" color="primary" >Agregar</Button>
            </DialogActions>
        </Dialog>
    )


}


